import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 41797 26999"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#1c1b17}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M20991 1266c81 144 160 289 237 435 36 68 73 138 109 207 77 148 152 296 226 445l82 167c75 153 148 306 219 460l90 196c71 156 141 313 209 471l64 151c72 170 142 341 210 513l59 150c68 174 134 349 199 525l41 115c68 187 132 375 196 564l39 119c61 186 119 372 176 559l29 97c60 200 117 401 171 603l23 87c53 198 103 396 151 595l20 82c50 210 96 420 141 632l14 67c43 214 85 428 124 643l6 38c40 224 76 448 110 673l6 42c33 223 63 447 90 672l3 33c28 229 52 459 72 690l3 34c20 231 37 463 51 695l1 11v13c14 233 25 468 31 703l1 26c7 239 11 480 11 721 0 240-4 481-11 721l-1 25c-6 235-17 470-31 703v13l-1 11c-14 232-31 464-51 695l-3 34c-20 231-44 461-72 690l-3 33c-27 225-57 449-90 672l-6 42c-34 225-70 450-110 673l-6 39c-39 215-81 429-124 642l-14 68c-45 211-91 422-141 632l-20 81c-48 200-98 398-151 596l-22 84c-55 203-112 405-172 605l-29 97c-57 188-115 374-176 559l-39 120c-64 188-128 376-196 563l-41 115c-64 176-131 351-199 525l-59 150c-68 172-138 343-210 513l-64 151c-68 158-138 315-209 471l-90 196c-71 154-144 308-219 460l-82 167c-74 149-149 298-226 445l-109 208c-77 145-156 290-237 434l-93 167-93-167c-80-144-159-289-236-434-37-69-73-138-110-208-76-147-151-296-226-445l-82-167c-74-152-147-306-219-460l-89-196c-72-156-141-313-209-471l-64-151c-72-170-142-341-211-513l-59-150c-67-174-133-349-198-525l-42-115c-67-187-132-375-195-563l-39-120c-61-185-120-371-176-559l-29-97c-60-200-118-402-172-605l-23-84c-52-198-102-396-150-596l-20-81c-50-211-97-421-141-632l-14-68c-44-213-85-427-124-642l-7-39c-39-223-76-448-110-673l-6-42c-33-223-62-447-89-672l-4-33c-27-229-51-459-71-690l-3-34c-21-231-38-463-52-695v-11l-1-13c-14-233-24-468-31-703v-25c-8-240-11-481-11-721 0-241 3-482 11-721v-26c7-235 17-470 31-703l1-13v-11c14-232 31-464 52-695l3-34c20-231 44-461 71-690l4-33c27-225 56-448 89-672l6-42c34-225 71-449 110-673l7-38c39-215 80-429 124-643l14-67c44-212 91-423 141-632l20-82c47-199 97-397 150-595l23-87c55-202 112-403 172-603l29-97c56-187 115-373 176-559l39-119c63-189 128-377 195-564l42-115c64-176 131-351 198-525l59-150c69-172 139-343 211-513l64-151c68-158 137-315 209-471l89-196c72-154 145-307 219-460l82-167c75-149 150-297 226-445l110-207c77-146 156-291 236-435l93-166 93 166z"
        className="stroke1 fill"
        style={{
          stroke: "#1c1b17",
          strokeWidth: 1072.24,
        }}
      />
      <rect
        width={41334}
        height={3307}
        x={232}
        y={11846}
        className="stroke1 fill"
        rx={12634}
        ry={8267}
        style={{
          stroke: "#1c1b17",
          strokeWidth: 463.179,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
